import { render, staticRenderFns } from "./InstallmentFormPedestal.vue?vue&type=template&id=0b9da7e6&"
import script from "./InstallmentFormPedestal.vue?vue&type=script&lang=js&"
export * from "./InstallmentFormPedestal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports